import Vue from "vue";
import VueRouter from "vue-router";
import {fb} from "../firebase";
import Admin from "../views/Admin/Admin.vue";
import Products from "../views/Admin/Products.vue";
import Profile from "../views/Admin/Profile.vue";
import AdminHome from "../views/Admin/Home.vue";
import App from "../views/App/App.vue";
import Home from "../views/App/Home.vue";
import SignIn from "../views/App/SignIn.vue";
import SignUp from "../views/App/SignUp.vue";
import Checkout from "../views/App/Checkout.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: App,
    children: [
      {
        path: "",
        name: "home",
        component: Home
      },
      {
        path: "signin",
        name: "signin",
        component: SignIn
      },
      {
        path: "signup",
        name: "signup",
        component: SignUp
      },
      {
        path: "checkout",
        name: "checkout",
        component: Checkout
      },
    ]
  },
  {
    path: "/admin",
    component: Admin,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "adminHome",
        component: AdminHome
      },
      {
        path: "products",
        name: "products",
        component: Products
      },
      {
        path: "profile",
        name: "profile",
        component: Profile
      }
    ]
  },
  // {
  //   path: "/admin",
  //   name: "admin",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/Admin.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  let user = fb.auth().currentUser;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!user) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
});

export default router;
